import { useEffect, useState } from "react"
import "../../Styles/dashboard/ViewOrder.css"
import Loader from "react-js-loader";
import { useNavigate } from "react-router"
import {IoMdArrowBack} from "react-icons/io"
import { modals } from '@mantine/modals';
import { Button, Select } from "@mantine/core"
import Sidebar from "../../components/dashboard/sidebar"


const ViewOrder = () => {


    const navigate = useNavigate()
    const [fetch, setFetched] = useState(false)

    useEffect(() => {
        setFetched(true)
    }, [])

    const editOrderStatus = (value) => {

    }

    const openModal = () => {
        let value 
        modals.open({
            title: `Change Order Status from ${"pending"}`,
            children: (
            <>
                <select name="" id="" 
                style={{
                    padding: '8px 10px',
                    width: '100%',
                    backgroundColor: 'white',
                    border: '1px solid rgb(193, 193, 193)',
                    borderRadius: '3px',
                    outline: 'none'
                }}>
                    <option value="PENDING">PENDING</option>
                    <option value="DELIVERED">DELIVERED</option>
                    <option value="CONFIRMED">CONFIRMED</option>
                    <option value="READY">READY</option>
                    <option value="RETURNED">RETURNED</option>
                    <option value="CANCELLED">CANCELLED</option>
                </select>
                <Button color="green" fullWidth onClick={() => editOrderStatus(value)} mt="md">
                    Submit
                </Button>
            </>
            ),
        })
    }

    return <>
        <Sidebar/>
        {
            !fetch ?
            <div className="loader">
                <Loader type="box-rectangular" bgColor={"rgb(190,142,30)"} title={"box-rotate-x"} color={'green'} size={50} />
            </div> :
        
        <div className="viewOrderContainer">
            <div className="viewOrderHeading">
                <div className="pageInfo">
                    <IoMdArrowBack onClick={() => navigate("/dashboard/orders")}/>
                    <h2>Order #456</h2>
                </div>
                <button onClick={openModal}>Change Order Status</button>
            </div>

            <div className="viewOrderWrapper">
                <div className="leftOrder">

                    <div className="userOrderWrapper">
                    <div className="orderCard" >
                                <div className="orderCardHeading">
                                    <div className="topHeading">
                                        <h2>#456</h2>
                                       <p className="pending">pending</p>
                                        
                                        <p><span>Payment Status: </span>paid</p>
                                    </div>
                                    <div className="bottomHeading">
                                        <p><span>Order date: <span></span></span>&nbsp; 25th Oct, 2023</p>
                                        <p>"Estimated delivery: 3 days after order date"</p>
                                    </div>
                                </div>
                                    <div className="orderCardMiddle">
                                        <img src="" alt="" />
                                        <div className="orderCardDetails">
                                            <div className="topDetails">
                                                <h3>Fresh Blueberries</h3>
                                                <p>N500</p>
                                            </div>
                                            <div className="bottomDetails">
                                                <p>  
                                                    <span>category: <span className="innerSpan">Fruits</span></span> 
                                                    <span>product id: <span className="innerSpan">#002</span></span>
                                                </p>
                                                <p><span>Qty</span>: 5</p>
                                            </div>
                                        </div>
                                    </div>
                                
                                <div className="total">
                                    <h3>SubTotal: <span>N100</span></h3>
                                        <h3>Delivery: <span>N3000.00</span></h3>
                                    <h3>Total: <span>N3100</span></h3>
                                </div>
                                <div className="orderCardBottom">
                                    <h2>Shipping Address</h2>
                                    <div className="orderAddress">
                                        <p>Edyco Plaza, First Mechanic Junction, East-West road</p>
                                        <p>Port Harcourt</p>
                                        <p>Rivers State</p>
                                        <p>Nigeria</p>
                                    
                                        
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div className="rightOrder">
                    <div className="heading">
                        <h3>Customer</h3>
                    </div>
                    <div className="userInfo">
                        <img src="" alt="" />
                        <h3>John Doe</h3>
                        <p className="email">johndoe@gmail.com</p>
                        <p className="email">+2348104009853</p>
                    </div>
                </div>
            </div>
        </div>
        }
    </>
}

export default ViewOrder